import { render, staticRenderFns } from "./RcvRL_Row_Items.vue?vue&type=template&id=0b967f5a"
import script from "./RcvRL_Row_Items.vue?vue&type=script&lang=js"
export * from "./RcvRL_Row_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports